import { FC } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectIsError, selectIsTournamentRoute } from '@state/pageSlice';
import { routes } from '@app/constant';
import LogoPng from '@assets/logo-grey.png';
import { Copyright } from './components/Copyright';
import './Footer.scss';

export const Footer: FC = () => {
    const { t } = useTranslation();
    const isTournamentRoute = useSelector(selectIsTournamentRoute);
    const isErrorRoute = useSelector(selectIsError);

    if (isErrorRoute) {
        return null;
    }

    return (
        <>
            <footer className={`custom-footer roadmater-section ${isTournamentRoute ? 'tournament-footer' : ''}`}>
                <Container>
                    <Row className="gy-4 mt-0">
                        <Col xs={12} md={12} className="text-center text-md-start mt-0">
                            <img src={LogoPng} alt="RoadMasterVr" height="30" />
                        </Col>
                    </Row>

                    <Row className="pt-1 border-top mt-0 mt-md-5 gy-3 footer-menu">
                        {!isTournamentRoute && (
                            <Col xs={12} md={8}>
                                <div className="d-flex flex-row flex-md-column h-100 justify-content-center">
                                    <ul className="m-0 list-unstyled d-flex gap-4 gap-md-2 flex-column flex-md-row">
                                        <li>
                                            <Link
                                                to={routes.learning}
                                                className="link-underline-opacity-0 link-opacity-75-hover link-underline-opacity-100-hover link-offset-3 link-secondary fs-8 d-flex align-items-center pe-2 pe-md-3 bsb-sep bsb-sep-border d-flex justify-content-center justify-content-md-start"
                                            >
                                                {t('page.learning')}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={routes.settings}
                                                className="link-underline-opacity-0 link-opacity-75-hover link-underline-opacity-100-hover link-offset-3 link-secondary fs-8 d-flex align-items-center pe-2 pe-md-3 bsb-sep bsb-sep-border d-flex justify-content-center justify-content-md-start"
                                            >
                                                {t('page.settings')}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={routes.termsConditions}
                                                className="link-underline-opacity-0 link-opacity-75-hover link-underline-opacity-100-hover link-offset-3 link-secondary fs-8 d-flex align-items-center pe-2 pe-md-3 bsb-sep bsb-sep-border d-flex justify-content-center justify-content-md-start"
                                            >
                                                {t('page.termsConditions')}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={routes.notifications}
                                                className="link-underline-opacity-0 link-opacity-75-hover link-underline-opacity-100-hover link-offset-3 link-secondary fs-8 d-flex align-items-center pe-2 pe-md-3 bsb-sep bsb-sep-border d-flex justify-content-center justify-content-md-start"
                                            >
                                                {t('page.notifications')}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={routes.help}
                                                className="link-underline-opacity-0 link-opacity-75-hover link-underline-opacity-100-hover link-offset-3 link-secondary fs-8 d-flex align-items-center d-flex justify-content-center justify-content-md-start"
                                            >
                                                {t('page.help')}
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                        )}
                        <Col xs={12} md={12} className="d-block">
                            <Copyright className="pt-4 pb-4" />
                        </Col>
                    </Row>
                </Container>
            </footer>
        </>
    );
};
